// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UMdD","comment":"styles_comment__3Thc_"};